<div
  *appHasAccess="['CARDS_VIEW']"
  class="saved-card">
  <ul class="saved-card__tab">
    <li
      [class.active]="tabSelect === 'activated'"
      (click)="selectTab('activated')"
      class="saved-card__tab-item">
      {{ "SAVED_CARD_PAGE.CARDS" | translate }}
    </li>
    <li
      [class.active]="tabSelect === 'deactivated'"
      (click)="selectTab('deactivated')"
      class="saved-card__tab-item">
      {{ "SAVED_CARD_PAGE.BLOCKED_CARD" | translate }}
    </li>
  </ul>
  <div
    *ngIf="tabSelect === 'activated'"
    class="saved-card__basic-card">
    <h2 class="headline">{{ "SAVED_CARD_PAGE.MAIN_CARD" | translate }}</h2>
    <app-card-item
      *ngIf="mainCard"
      (deleteCardEvent)="openModalDeleteCard($event)"
      [item]="mainCard">
    </app-card-item>
  </div>
  <div class="saved-card__additional-card">
    <h2  class="headline">
      {{ ("SAVED_CARD_PAGE." + (tabSelect === 'activated' ? 'ADDITIONAL_CARD' : 'BLOCKED_CARD')) | translate}}
    </h2>

    <div
      *ngIf="tabSelect === 'activated'"
      class="tab-content">
      <div
        [class.active]="menuState"
        class="saved-card__additional-card-block">
        <button
          *appHasAccess="['CARDS_ADD']"
          (click)="openAddCardModal()"
          class="add-card">
          <img
            src="assets/img/add-card.svg"
            alt="Add card"
            class="add-card__icon" />
          <span class="add-card__description">{{ "SAVED_CARD_PAGE.ADD_CARD" | translate }}</span>
        </button>
        <div
          *ngFor="let item of activeCardList"
          class="item">
          <app-card-item
            (deleteCardEvent)="openModalDeleteCard($event)"
            [item]="item">
          </app-card-item>
        </div>
      </div>

      <button
        *appHasAccess="['CARDS_ADD']"
        (click)="openAddCardModal()"
        class="btn btn-accent">
        <img
          src="assets/img/add.svg"
          alt="Add" />
        {{ "SAVED_CARD_PAGE.ADD_CARD" | translate }}
      </button>
    </div>
    <div
      *ngIf="tabSelect === 'deactivated'"
      class="tab-content">
      <div
        [class.active]="menuState"
        class="saved-card__additional-card-block">
        <div
          *ngFor="let item of blockedCardList"
          class="item">
          <app-card-item
            (deleteCardEvent)="openModalDeleteCard($event)"
            [isEditable]="true"
            [item]="item">
          </app-card-item>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal
  [isFull]="true"
  [isOpenModal]="isAddCardModalDialog">
  <app-add-new-card-dialog (cardCreated)="cardCreated()"> </app-add-new-card-dialog>
</app-modal>

<app-modal [isOpenModal]="isDeleteCardModalDialog">
  <app-delete-card-dialog [cardData]="deleteCardData"> </app-delete-card-dialog>
</app-modal>

<app-modal [isOpenModal]="isDeleteSuccessCardModalDialog">
  <app-delete-card-success-dialog></app-delete-card-success-dialog>
</app-modal>

<app-modal [isOpenModal]="isAddSuccessCardModalDialog">
  <app-add-card-success-dialog></app-add-card-success-dialog>
</app-modal>
